import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru.json';
import en from './en.json';
import es from './es.json';
import ptBR from './pt-BR.json';
import hi from './hi.json';
import id from './id.json';
import tr from './tr.json';
import ko from './ko.json';
import { getLocale } from './langConfig';

const locale = getLocale();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ru: { translation: ru },
    es: { translation: es },
    'pt-BR': { translation: ptBR },
    hi: { translation: hi },
    id: { translation: id },
    tr: { translation: tr },
    ko: { translation: ko },
  },
  lng: locale,
  fallbackLng: 'en',
  supportedLngs: ['en', 'ru', 'es', 'pt-BR', 'hi', 'id', 'tr', 'ko'],
  load: 'currentOnly',
  interpolation: { escapeValue: false }
});

window.__i18n_debug = { locale, deviceLang: navigator.language };
export default i18n;
